import React, { Component } from "react";
import { getCMS } from "../services/cmsService";

export class AboutUs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cms: [],
    };
  }

  async componentDidMount() {
    try {
      const cmsData = await getCMS("about");

      this.setState({
        cms: cmsData,
      });

      console.log("ABOUT CMS:", cmsData);
    } catch (error) {
      console.log(error);
    }
  }

  render() {
    const { cms } = this.state;

    const aboutImage = cms.find(
      (item) => item.content_type === "1"
    );

    const highlightTitle = cms.find(
      (item) => item.content_type === "9"
    );

    const mainTitle = cms.find(
      (item) => item.content_type === "2"
    );

    const paragraphs = cms.filter(
      (item) => item.content_type === "3"
    );

    const features = cms.filter(
      (item) => item.content_type === "13"
    );

    const buttonText = cms.find(
      (item) => item.content_type === "10"
    );

    return (
      <div>
        {/* About Start */}
        <div className="container-fluid py-5">
          <div className="container">

            <div className="row g-5 align-items-center">

              {/* About Image */}
              <div
                className="col-lg-6 wow fadeIn"
                data-wow-delay="0.2s"
              >
                <img
                  className="img-fluid"
                  src={aboutImage?.content_image || ""}
                  alt="About Ideal Technoride"
                />
              </div>

              {/* About Content */}
              <div
                className="col-lg-6 wow fadeIn"
                data-wow-delay="0.5s"
              >
                <h1 className="mb-4">
                  <span className="text-uppercase bg-primary text-white rounded px-2">
                    {highlightTitle?.content_title}
                  </span>{" "}
                  {mainTitle?.content_title}
                </h1>

                {paragraphs.map((item) => (
                  <p
                    key={item.content_id}
                    className="mb-4"
                  >
                    {item.content_paragraph}
                  </p>
                ))}

                <div className="row g-3">

                  <div className="col-sm-6">
                    {features.slice(0, 2).map((item) => (
                      <h6
                        key={item.content_id}
                        className="mb-3"
                      >
                        <i className="fa fa-check text-primary me-2"></i>
                        {item.content_title}
                      </h6>
                    ))}
                  </div>

                  <div className="col-sm-6">
                    {features.slice(2, 4).map((item) => (
                      <h6
                        key={item.content_id}
                        className="mb-3"
                      >
                        <i className="fa fa-check text-primary me-2"></i>
                        {item.content_title}
                      </h6>
                    ))}
                  </div>

                </div>

                <div className="d-flex align-items-center mt-4">

                  <a
                    className="btn btn-primary py-3 px-4 me-2"
                    href="/about"
                  >
                    {buttonText?.content_title || "Read More"}
                  </a>

                </div>

              </div>

            </div>

          </div>
        </div>
        {/* About End */}
      </div>
    );
  }
}

export default AboutUs;